const hasTitleConversationGroup = (
  conversation,
  teamName,
  receiverName = "",
) => {
  if (conversation && conversation?.name) {
    return conversation.name;
  }

  if (teamName) return teamName;

  return receiverName;
};

export default hasTitleConversationGroup;
